import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '@store/partners-order/PartnersOrderState';
import { hasOwnPropertyTS } from '@components/utils';
import { DeliveryTypeDef } from '@api/types/DeliveryTypeDef';
import { PaymentTypeDef } from '@api/types/PaymentTypeDef';
import { DispatchPoint } from '@api/types/DispatchPoint';
import { CountryEnum } from '@api/types/CountryEnum';



export const partnersOrderSlice = createSlice({
	name: 'partnersOrder',
	initialState,
	reducers: {
		setShowInvalids: (state, action: PayloadAction<boolean>) => {
			state.showInvalids = action.payload
		},
		setCustomer: (state, action: PayloadAction<string | null>) => {
			state.customer = action.payload;
		},
		setEmail: (state, action: PayloadAction<string | null>) => {
			state.email = action.payload;
		},
		setPhoneNumber: (state, action: PayloadAction<string | null>) => {
			state.phoneNumber = action.payload;
		},
		setStreet: (state, action: PayloadAction<string | null>) => {
			state.street = action.payload;
		},
		setCity: (state, action: PayloadAction<string | null>) => {
			state.city = action.payload;
		},
		setPostalCode: (state, action: PayloadAction<string | null>) => {
			state.postalCode = action.payload;
		},
		setInvoiceStreet: (state, action: PayloadAction<string | null>) => {
			state.invoiceStreet = action.payload;
		},
		setInvoiceCity: (state, action: PayloadAction<string | null>) => {
			state.invoiceCity = action.payload;
		},
		setInvoicePostalCode: (state, action: PayloadAction<string | null>) => {
			state.invoicePostalCode = action.payload;
		},
		setRegistrationNumber: (state, action: PayloadAction<string | null>) => {
			state.registrationNumber = action.payload;
		},
		setVatnumber: (state, action: PayloadAction<string | null>) => {
			state.vatnumber = action.payload;
		},
		setMessage: (state, action: PayloadAction<string | null>) => {
			state.message = action.payload;
		},
		setPayment: (state, action: PayloadAction<PaymentTypeDef | null>) => {
			let previous = state.payment;
			let next = action.payload;
			if (!previous && next) {
				state.payment = action.payload;
				return;
			}
			if (previous && next && previous.id !== next.id) {
				state.payment = action.payload;
				return;
			}
			state.payment = initialState.payment;
		},
		setDelivery: (state, action: PayloadAction<DeliveryTypeDef | null>) => {
			let previous = state.delivery;
			let next = action.payload;
			if (!previous && next) {
				state.delivery = action.payload;
				return;
			}
			if (previous && next && previous.id !== next.id) {
				state.delivery = action.payload;
				state.dispatchPoint = initialState.dispatchPoint;
				return;
			}
			state.delivery = initialState.delivery;
		},
		setDispatchPoint: (state, action: PayloadAction<DispatchPoint | null>) => {
			state.dispatchPoint = action.payload;
		},
		updateOrderedDogsUnitsItem: (state, action: PayloadAction<{ label: string, value: number }>) => {
			let objectKey = `size${action.payload.label}`;
			if (hasOwnPropertyTS(state.orderedDogsUnits, objectKey)) {
				state.orderedDogsUnits[objectKey] = action.payload.value;
			}
		},
		updateOrderedCatsUnitsItem: (state, action: PayloadAction<{ label: string, value: number }>) => {
			let objectKey = `size${action.payload.label}`;
			if (hasOwnPropertyTS(state.orderedCatsUnits, objectKey)) {
				state.orderedCatsUnits[objectKey] = action.payload.value;
			}
		},
		updateOrderedCatsCollarUnitsItem: (state, action: PayloadAction<{ label: string, value: number }>) => {
			let objectKey = `size${action.payload.label}`;
			if (hasOwnPropertyTS(state.orderedCatsCollarUnits, objectKey)) {
				state.orderedCatsCollarUnits[objectKey] = action.payload.value;
			}
		},
		setTestSamples: (state, action: PayloadAction<boolean>) => {
			state.testSamples = action.payload;
		},
		setCountry: (state, action: PayloadAction<CountryEnum>) => {
			state.country = action.payload;
		},
		resetStore: (_) => initialState,
	},
});

export default partnersOrderSlice.reducer;



export const {
	setShowInvalids,
	setCustomer,
	setEmail,
	setPhoneNumber,
	setStreet,
	setCity,
	setPostalCode,
	setInvoiceStreet,
	setInvoiceCity,
	setInvoicePostalCode,
	setRegistrationNumber,
	setVatnumber,
	setMessage,
	setPayment,
	setDelivery,
	setDispatchPoint,
	updateOrderedDogsUnitsItem,
	updateOrderedCatsUnitsItem,
	updateOrderedCatsCollarUnitsItem,
	setTestSamples,
	setCountry,
	resetStore } = partnersOrderSlice.actions;